import React, { useContext, useEffect } from "react";
import {Context} from "..";
import { getProducts } from "../http/productAPI";

import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ProductList from "../components/ProductList";
import '../components/FrontProductsBlock.css';



const promotions = [
  {
    id: 1,
    title: 'Товары со скидкой',
    description: 'Выбирайте из ассортимента кондиционеров по сниженным ценам.',
    image: 'discount.jpg',
    link: '/catalog?promotion=discount',
  },
  {
    id: 2,
    title: 'Бесплатный монтаж',
    description: 'При покупке сплит-системы — монтаж за наш счёт!',
    image: 'free-installation.jpg',
    link: '/catalog?promotion=free-installation',
  },
  {
    id: 3,
    title: 'Скидка на монтаж',
    description: 'Сэкономьте до 30% на установке при заказе через сайт.',
    image: 'install-discount.jpg',
    link: '/catalog?promotion=install-discount',
  },
];
    


const PromotionsPage = () => {
  const navigate = useNavigate();
  const {user, product} = useContext(Context)
    product.setSelectedFilters(null);
    const selectedFolderFilters = product.requestBodyFilter;       
    product.setSelectedFolder({ id: "2" });

    useEffect(() => {
        getProducts(product.selectedFolder.id, 0, 20000, selectedFolderFilters).then(data => product.setProducts(data.products))
    }, [product.search, product.selectedFolder])

    /* не понятная сортировка
     getProducts("2", 0, 20000, selectedFolderFilters).then(data => {
      product.setProducts(data.products);

      const filtered = data.products.filter((p) => {
        switch (promotionKey) {
          case 'discount':
            return p.isSale;
          case 'free-installation':
            return p.freeInstall;
          case 'install-discount':
            return Array.isArray(p.attributes) && p.attributes.some(attr =>
              attr.name?.toLowerCase().includes("скидка на монтаж")
            );
          default:
            return true; // показать все, если параметр отсутствует
        }
      });

      setFilteredProducts(filtered);
    });

  }, [promotionKey]);
*/

  return (
    <div className="py-4">
    <Container className="py-5">
      <h1 className="mb-4 text-center">Актуальные акции</h1>
      <Row>
        {promotions.map((promo) => (
          <Col key={promo.id} md={6} lg={4} className="mb-4">
            <Card
              onClick={() => navigate(promo.link)}
              className="h-100 shadow-sm promo-card"
              style={{ cursor: 'pointer' }}
            >
              <Card.Img
                variant="top"
                src={require(`../assets/img/${promo.image}`)}
                alt={promo.title}
                style={{ height: '200px', objectFit: 'cover' }}
              />
              <Card.Body>
                <Card.Title>{promo.title}</Card.Title>
                <Card.Text>{promo.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
                

    </Container>

    <Container className="mb-4 products d-flex justify-content-start flex-wrap align-items-stretch px-0">
                <ProductList/>                  
     </Container>
     </div>
  );
};

export default PromotionsPage;
